import { CheckboxControl } from "@/Common/Components/Inputs/CheckboxControl";
import { RadioButtonv2 } from "@/Common/Components/Inputs/RadioButtonv2";
import { TextboxControl } from "@/Common/Components/Inputs/TextboxControl";
import { SearchSettingsFooter } from "@/Common/Components/Settings/SearchSettingsFooter";
import { Person } from "@/Common/Models/Person/Person";
import { SearchableItemModelT } from "@/Common/Models/SearchableItem";
import { PortfolioInboxes } from "@/Common/Models/UI/Enums";
import { KeyValuePair } from "@/Common/Models/UI/KeyValuePair";
import * as LocalOperations from "@/Common/Operations/operations.local";
import { ApssFilterType, IAPSSInboxModel } from "@/Portfolio/Models/UI/IAPSSInboxModel";

import "./ApssSettingsContainer.css";

interface IApssSettingsContainerProps {
    model: IAPSSInboxModel;
    Type: PortfolioInboxes;
    onClick?: any;
    id?: string;
    className?: string;
    style?: any;
    onCloseCallback: () => void;
    reloadOpetation: number;
    isFromConseilNumerique: boolean;
}

class ApssSettingsContainer extends React.Component<IApssSettingsContainerProps, never> {
    private employees: Immutable.List<SearchableItemModelT<Person>> = cacheStore.Clinicians.filter(x => !IsNullOrWhiteSpace(x.EmployeeModel.FirstLicenceNumber)).map(x => new SearchableItemModelT<Person>(x.NameWithPrefix + " (" + x.Licence + ")", x.ContactId, x)).toImmutable();

    public render(): JSX.Element {
        const selectedEmployee = this.props.model.get("SelectedEmployee");
        const settingsClass = `${this.props.className} apps-settings`;

        return (
            <div id={this.props.id} className={settingsClass} style={this.props.style} onClick={this.props.onClick}>
                <table className="f-content table-settings">
                    <thead>
                        <tr>
                            <th>
                                {this.props.model.get("FilterType") == ApssFilterType.ParCreateur &&
                                    <label className="settings-lblClinicians">{cacheStore.GetString("ParCreateurLabel")}</label>
                                }
                                {this.props.model.get("FilterType") == ApssFilterType.ParLicenceMDReferant &&
                                    <label className="settings-lblClinicians">{cacheStore.GetString("ParLicenceMDReferantLabel")}</label>
                                }
                            </th>
                            <th>
                                <label className="settings-lblEmpty" />
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td className="settings-row-Clinicians">
                                <div className="settings-selectedEmployee">
                                    {selectedEmployee == null && (
                                        <TextboxControl
                                            value=""
                                            autoCompleteItems={this.employees}
                                            onAutoCompleteSelectCallBack={(code, value: Person) => {
                                                sessionStore.dispatch(LocalOperations.Portfolio.APSS_SearchSettings_ChangeEmployee, { value });
                                            }}
                                            onAutoCompleteSelectClearTextBox={false}
                                            className="settings-txtbox-noEmployee"
                                            placeholder=""
                                            onMountFocus={true}
                                        />
                                    )}
                                    {selectedEmployee != null && (
                                        <div className="settings-Employee-container">
                                            <div className="flex-container" style={{ justifyContent: "flex-start" }}>
                                                <div className="settings-EmployeeName">{selectedEmployee.NameWithPrefix + " (" + selectedEmployee.Licence + ")"}</div>
                                                <div
                                                    className="pointer red"
                                                    onClick={() => {
                                                        sessionStore.dispatch(LocalOperations.Portfolio.APSS_SearchSettings_ChangeEmployee, { value: null });
                                                    }}
                                                >
                                                    <span>X</span>
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                    <RadioButtonv2
                                        htmlName="FilterType"
                                        items={[
                                            new KeyValuePair<ApssFilterType, string>(ApssFilterType.ParCreateur, cacheStore.GetString("ParCreateurLabel")),
                                            new KeyValuePair<ApssFilterType, string>(ApssFilterType.ParLicenceMDReferant, cacheStore.GetString("ParLicenceMDReferantLabel"))
                                        ].toImmutable()}
                                        selectedItem={this.props.model.get("FilterType")}
                                        onChangeCallback={value => {
                                            portfolioStore.apssInboxModel = portfolioStore.apssInboxModel.set("FilterType", value.Key);
                                            portfolioStore.EmitChangeToListeners();
                                        }}
                                    />
                                </div>
                            </td>
                            <td>
                                <div>
                                    <div>
                                        <CheckboxControl checked={this.props.model.get("ShowPrerequisManquant")} operation={LocalOperations.Portfolio.APSS_OnShowOnlyMissingRequierementChange} label="Prérequis manquants" />
                                    </div>
                                    {this.props.Type === PortfolioInboxes.APSS_Purges && (
                                        <div>
                                            <CheckboxControl checked={this.props.model.get("ShowArchivedPurges")} operation={LocalOperations.Portfolio.APSS_OnShowArchivedPurgesChange} label={cacheStore.GetString("APSS_ShowArchivedPurgesLabel")} />
                                        </div>
                                    )}
                                    {this.props.Type === PortfolioInboxes.APSS_ConseilNumerique && (
                                        <div>
                                            <CheckboxControl
                                                checked={this.props.model.get("ShowArchivedConseilNumerique")}
                                                label={cacheStore.GetString("APSS_ShowArchivedPurgesLabel")}
                                                onChange={() => sessionStore.dispatch(LocalOperations.Portfolio.APSS_OnShowArchivedConseilNumerique)}
                                            />
                                        </div>
                                    )}
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <SearchSettingsFooter
                    onClose={() => this.props.onCloseCallback()}
                    onOk={() => this.props.onCloseCallback()}
                    onColumnOrderingButtonClick={() => sessionStore.dispatch(LocalOperations.Portfolio.APSS_SearchSettings_ShowColumnOrdering)}
                    onResultsPerPageChange={value => sessionStore.dispatch(LocalOperations.Portfolio.APSS_OnSettingsContainerPerPageChange, { value })}
                    selectedPageSizeOption={this.props.isFromConseilNumerique ? this.props.model.get("ConseilNumeriqueSelectedPageSizeOption") : this.props.model.get("SelectedPageSizeOption")}
                    pageSizeOptions={this.props.model.get("PageSizeOptions").toArray()}
                />
            </div>
        );
    }
}

export { ApssSettingsContainer };
